









import { Vue, Component } from 'vue-property-decorator';
import InfoIcon from '../icons/InfoIcon.vue';

@Component({
  components: {
    InfoIcon
  }
})
export default class ExpandPanel extends Vue {}
